meedy.controller('meedy.doctorListController', ['$rootScope', '$scope', '$state', '$mdToast', '$mdDialog', '$translate',
    'meedy.objectHelper', 'applicationModel', 'meedy.userModel', 'meedy.resourceDetailsModel',
    function ($rootScope, $scope, $state, $mdToast, $mdDialog, $translate, objectHelper, applicationModel, userModel,
              resourceDetailsModel) {

        var listeners = {};

        function setData() {
            $scope.offices = [];
            $scope.criteria = new ResourceDataGridMeedyCriteria();
            $scope.criteria.rowsPerSheet = 100000;

            $scope.columns = [
                {
                    field: "firstName + ' ' + lastName",
                    displayName: $translate.instant('T.MEEDY.MODULE.OFFICE.PHYSICIAN')
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.PERSONAL_DATA.SPECIALIZATION'),
                    cellTemplate: 'meedy/application/view/app/settings/doctor/grid-templates/data-doctor-list-specialization.html'
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.USER.ACTION'),
                    cellTemplate: 'meedy/application/view/app/settings/doctor/grid-templates/data-doctor-list-action.html'
                }
            ];

            $scope.currentState = Constant.STATE.APP.MEEDY.SETTINGS.OFFICE.LIST;
            $scope.Constant = Constant;
        }

        function setPermissions() {
            $scope.isPhysician = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.PHYSICIAN;
            $scope.isReceptionist = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.MEDICAL_RECEPTIONIST
            ||  userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.RECEPTIONIST;
        }

        function setListeners() {
            listeners.onDataPageLoad = function(dataPage) {
                $scope.doctors = dataPage.data;
                $scope.numberOfPages = dataPage.numberOfPages;
            };

            $scope.$on(Event.MEEDY.RESOURCE.DELETE.SUCCESS, function(event, offices) {
                resourceDetailsModel.getDataPage($scope.criteria).then(listeners.onDataPageLoad);
            });

            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });
        }

        function setActions() {

            $scope.createNewOffice = function() {
                $state.go(Constant.STATE.APP.MEEDY.SETTINGS.DOCTOR.CREATE);
            };

            $scope.editOffice = function(doctor) {
                $state.go(Constant.STATE.APP.MEEDY.SETTINGS.DOCTOR.EDIT, {id : doctor.id});
            };

            $scope.criteriaChanged = function() {
                resourceDetailsModel.getDataPage($scope.criteria).then(listeners.onDataPageLoad);
            };

            $scope.deleteDoctor = function(doctor) {

                var confirm = $mdDialog.confirm({
                    title: $translate.instant('T.MEEDY.MODULE.USER.USER_DELETE_CONFIRMATION'),
                    ok: $translate.instant('T.MEEDY.UI.APPLICATION.YES'),
                    cancel: $translate.instant('T.MEEDY.UI.APPLICATION.NO')
                });
                $mdDialog.show(confirm).then(function() {
                    resourceDetailsModel.delete(doctor.id).then(function () {
                        resourceDetailsModel.getDataPage($scope.criteria).then(listeners.onDataPageLoad);
                    })
                }, function() {
                    return false;
                });
            };
        }

        function configureInterface() {
            applicationModel.selectMenuItemWithState(Constant.STATE.APP.MEEDY.SETTINGS.MY_DATA);

            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.MEEDY.UI.APPLICATION.SETTINGS');
        }

        function initialize() {
            resourceDetailsModel.getDataPage($scope.criteria).then(listeners.onDataPageLoad);
            applicationModel.viewReady = true;
            applicationModel.fillViewportMode = true;
            $scope.showAddButton($scope.createNewOffice);
            $scope.hideBackButton();
            $scope.resetTitle();
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
